module.exports = __webpack_public_path__ + "static/media/6c_website_logo_Platinum_fse.2cddcf02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/6c_website_logo_Platinum_fse.jpg
// module id = 98
// module chunks = 0